/**
 * MailChimp Management Page
 * Admin page for managing MailChimp integration
 */

import React from 'react';
import { AdminRoute } from '../../components/auth/AdminRoute';
import MailChimpIntegrationDashboard from '../../components/mailchimp/MailChimpIntegrationDashboard';

const MailChimpManagementPage = () => {
  return (
    <AdminRoute>
      <MailChimpIntegrationDashboard />
    </AdminRoute>
  );
};

export default MailChimpManagementPage;
